import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import PublishIcon from "@mui/icons-material/LanguageRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { MessagePublishStatus } from "../../../../../api/types/documentCollectionTypes";
import FileAccessIcon from "@entrilia/shared/icons/FileAccessIcon";
import UnpublishIcon from "@entrilia/shared/icons/UnpublishIcon";
import DocumentCollectionContext from "../DocumentCollectionContext";
import type { DocumentAccessOption } from "./documentAccessHelper";

interface Props {
  id: string;
  postMessageRequestId: string;
  name: string;
  publishingStatus: MessagePublishStatus;
  currentDocumentsAccess: DocumentAccessOption[];
}

const DocumentActionsCell = ({ id, postMessageRequestId, name, publishingStatus, currentDocumentsAccess }: Props) => {
  const {
    documentCollection,
    hasPermissionsToManage,
    investorPortalEnabled,
    onChangeDocumentsStatus,
    onChangeDocumentsAccess,
  } = useDefinedContext(DocumentCollectionContext);

  if (!hasPermissionsToManage) {
    return null;
  }

  const isStatusChangeAllowed = documentCollection.messageSource === "DataImport";

  return (
    <ActionsMenuButton
      items={[
        {
          label: "Change File Access",
          icon: <FileAccessIcon />,
          onClick: () => onChangeDocumentsAccess([{ id, postMessageRequestId }], currentDocumentsAccess),
          hidden: !investorPortalEnabled,
        },
        {
          label: "Publish to Live",
          icon: <PublishIcon />,
          onClick: () => onChangeDocumentsStatus("MakeLive", [postMessageRequestId], name),
          hidden: !isStatusChangeAllowed,
          disabled: publishingStatus === "Live",
        },
        {
          label: "Unpublish to Preview",
          icon: <UnpublishIcon />,
          onClick: () => onChangeDocumentsStatus("MakePreview", [postMessageRequestId], name),
          hidden: !isStatusChangeAllowed,
          disabled: publishingStatus === "Preview",
        },
        {
          label: "Delete",
          icon: <DeleteIcon color="error" />,
          onClick: () => onChangeDocumentsStatus("Revoke", [postMessageRequestId], name),
          hidden: !isStatusChangeAllowed,
        },
      ]}
    />
  );
};

export default DocumentActionsCell;
